import { timeout } from '../helpers/base'

export function globalCall() {

	const $doc    = $(document)
	const $window = $(window)
	const $body   = $('body')
	const $header = $('#header');
	const isHome  = $body.hasClass('body-home')

	void function body_anim(params) {
		const cssTransitionTime = 150

		$body.removeClass('body-anim')

		$('a').on('click', function(ev) {
			if (ev.ctrlKey) return

			const href = this.getAttribute('href')

			if (window.location.href.indexOf(href) >= 0) return

			if (href.indexOf($_GP.SITE_URL) >= 0) {
				ev.preventDefault()
				$body.addClass('body-anim')
				setTimeout(() => { window.location = this.href}, cssTransitionTime);
			}
		})
	}()

	void function drawer() {
		const $drawer = $$('drawer')
		if (!$drawer.length) return

		let $_DRAWER_OPEN = null

		function closeDrawers() {
			$body.removeClass('header-drawer-is-open')
			$_DRAWER_OPEN.removeClass('is-open')
			$_DRAWER_OPEN.trigger('gp:drawerClose')
			$_DRAWER_OPEN = null
		}

		function openDrawer($target) {
			if ($_DRAWER_OPEN !== null) {
				$_DRAWER_OPEN.removeClass('is-open')
			}

			$body.addClass('header-drawer-is-open')
			$target.addClass('is-open')
			$_DRAWER_OPEN = $target
			$_DRAWER_OPEN.trigger('gp:drawerOpen')
		}

		function toggleDrawer($target) {
			if ( $_DRAWER_OPEN && ($_DRAWER_OPEN[0] !== $target[0]) ) {
				closeDrawers()
			}

			if ($_DRAWER_OPEN !== null) {
				closeDrawers()
			} else {
				openDrawer($target)
			}
		}

		$doc.on('click', '[data-se="drawerToggle"]', function(ev) {
			const $this = $(this)
			const $target = $($this.data('target'))
			if (!$target.length) return
			$this.tooltip('hide')
			toggleDrawer($target)
		})

		$doc.on('click', '[data-se="drawerClose"]', closeDrawers)

		$.fn.drawer = function(action) {
			if (action === 'toggle') {
				toggleDrawer($(this))
			}
			if (action === 'open') {
				openDrawer($(this))
			}
			if (action === 'close') {
				closeDrawers()
			}
			return this
		}

		// copy navbar
		$('#drawer-navbar').find('.drawer-body').append($('#navbar').html())
	}()

	function twbsCalls() {
		const dropdownMenu = $('ul.dropdown-menu [data-toggle=dropdown]');
		dropdownMenu.on('click', function(ev) {
			ev.preventDefault();
			ev.stopPropagation();
			const $thisParent = $(this).parent()

			if ($thisParent.hasClass('open')) {
				$thisParent.removeClass('open')
				return
			}

			dropdownMenu.parent().removeClass('open')
			$thisParent.addClass('open')
		});

		// tooltips
		// data-has="tooltip" resolve conflick with data-toggle="dropdow"
		$body.tooltip({
			selector: '[data-toggle="tooltip"],[data-has="tooltip"]',
			container: 'body',
			html: true,
		})

		$body.on('click', '[data-has="tooltip"]',function() {
			$_GP._.timeout(() => $(this).trigger('blur') , 10);
		})

		$(document).on('click', '.dropdown-menu[data-se="dropdownStopPropagation"]', function(e) {
			e.stopPropagation();
		});
	}

	function fullScreen() {
		//https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
		if (!('requestFullscreen' in document.documentElement)) return

		function toggleFullScreen() {
			if (!document.fullscreenElement) {
					document.documentElement.requestFullscreen();
			} else {
				if (document.exitFullscreen) {
					document.exitFullscreen();
				}
			}
		}

		$$('toggleFullScreen').on('click', toggleFullScreen)
	}

	function scrollTo() {
		$$('scrollTo').on('click', function(ev) {
			const $this = $(this)
			const $target = $($this.data('target'))
			if (!$target.length) return

			const dist = $target.offset().top
			$('html,body').stop().animate({scrollTop: dist})
			$this.trigger('blur')
		})
	}

	function cookieWarning() {
		$(function() {
			const warning       = $('#browser-cookie-warning');
			const btn           = warning.find('button');
			const warningClosed = Cookies.get('gpb_cookieWarningClosed');

			if (!warningClosed) warning.addClass('show');

			btn.on('click', ()=> Cookies.set('gpb_cookieWarningClosed', 'true', { expires: 365 }));
		});
	}

	function customValidity() {
		if (!('setCustomValidity' in document.createElement('input'))) return

		const $triggerTo = $('[data-valid-equal-to]')
		const $triggerFrom = $('[data-valid-equal-from]')
		if (!$triggerTo.length && !$triggerFrom.length) return

		$triggerTo.on('keyup change', function(ev) {
			const $this = $(this)
			const target = $this.data('valid-equal-to')
			const $target = $this.closest('form').find(`[data-se="${target}"]`)
			console.log($this.val() !== $target.val())
			if ( $this.val() !== $target.val() ) {
				$target[0].setCustomValidity($target.attr('title'));
			} else {
				$target[0].setCustomValidity('');
			}
		});

		$triggerFrom.on('keyup change', function(ev) {
			const $this = $(this)
			const target = $this.data('valid-equal-from')
			const $target = $this.closest('form').find(`[data-se="${target}"]`)
			console.log($this.val() !== $target.val())
			if ( $this.val() !== $target.val() ) {
				this.setCustomValidity($this.attr('title'));
			} else {
				this.setCustomValidity('');
			}
		});
	}

	const editorIframeYT = function() {
		const ytIframe16by9 = $('.content-editable iframe[src*="www.youtube.com"]:not(.content-editable .embed-responsive-16by9 iframe[src*="www.youtube.com"])');

		if (ytIframe16by9.length > 0) {
			ytIframe16by9.attr('allowfullscreen', '')
				.wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
		}
	}

	const windowScrollResize = function() {
		// let FIXED_WARNING = false;
		const $headerWarning = $header.find('.header-warning')

		// DISABLED HIDE ON SCROLL
		// for now this is only for header-warning
		if (!$headerWarning.length) return
		const hasHeaderWarning = Boolean($headerWarning.length)

		// function headerWarningScroll(distTop) {
			// const headerWarningHeight = $headerWarning.outerHeight() + 2

			// if (!FIXED_WARNING && distTop > 50) {
			// 	$header.css('transform', `translate3d(0,-${headerWarningHeight}px,0)`)
			// 	FIXED_WARNING = true;
			// }

			// if (FIXED_WARNING && distTop <= 50 ) {
			// 	$header.css('transform', `translate3d(0,0,0)`)
			// 	FIXED_WARNING = false;
			// }
		// }

		function resizeHandler() {
			$body.css('padding-top', $header.height())
		}

		// function scrollHandler() {
			// const distTop = $window.scrollTop();

			// if (hasHeaderWarning){
			// 	headerWarningScroll(distTop)
			// }
		// }

		// scrollHandler()
		// $window.on('scroll', $_GP._.throttle(scrollHandler))

		if (hasHeaderWarning) {
			$body.addClass('header-has-warning')

			if (!isHome) {
				resizeHandler()
				$window.on('resize', $_GP._.throttle(resizeHandler))
			}
		}
	}

	const openModals = function() {
		const maybeJq = function(string) {
			try {
				return $(string)
			} catch (error) {
				console.log('Syntax error, unrecognized expression: '+ string)
			}
			return $('')
		}

		const openModal = function(ev, elm) {
			const $elm = maybeJq(elm)

			if ($elm.length && $elm.hasClass('modal')) {
				if (ev) {
					ev.preventDefault()
				} else {
					if ('pushState' in history) {
						history.pushState('', document.title, window.location.pathname + window.location.search);
					}
				}
				$elm.modal('show')
			}
		}

		openModal(false, window.location.hash)

		$('a').on('click', function(ev) {
			const $this = $(this)
			if (Object.keys($this.data()).length > 0) return

			const href = $this.attr('href')
			if (href.indexOf('#') < 0) return

			const hash = href.split('#')
			if (hash.length !== 2) return

			const isSimpleHash = hash[0].length === 0 // href="#modal-cta"
			if (isSimpleHash) {
				openModal(ev, '#'+ hash[1])
				return
			}

			// const isThisPage = hash[0].indexOf(location.pathname) >=0
			// if (!isThisPage) return

			const isHere = hash[0].indexOf($_GP.SITE_URL) >= 0
			if (isHere) openModal(ev, '#'+ hash[1])
		})
	}

	const copyToClipboard = function() {
		const $btn = $$('copyToClipboard')
		if (!$btn.length) return

		function copy(str, success, error) {
			const textArea = document.createElement('textarea')
			textArea.value = str;

			textArea.style.top = '0';
			textArea.style.left = '0';
			textArea.style.position = 'fixed';
			textArea.style.zIndex = -1;
			textArea.style.transform = 'translate(-200%, -200%)';

			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();

			try {
				var wasCopied = document.execCommand('copy');
				if (wasCopied) {
					spop({ template: success, style: 'success', group: 'copyToClipboard', autoclose: 5000 });
				} else {
					spop({ template: error, style: 'error', group: 'copyToClipboard' });
				}
			} catch (err) {
				spop({ template: error, style: 'error', group: 'copyToClipboard' });
			}

			document.body.removeChild(textArea);
		}

		$btn.on('click', function() {
			const $this = $(this)

			const content = $this.attr('data-content')
			if (!content.length) return

			const success = $this.attr('data-success')
			const error = $this.attr('data-error')

			copy(content, success, error)
		})
	}

	$(document).on('keydown', 'form', function(ev){
		if (ev.key === 'Enter' && this.hasAttribute('data-disable-enter') ) {
			ev.preventDefault();
			return false;
		}
	});

	// fix in ff, ckeditor dialog input focus in modal
	// https://stackoverflow.com/questions/22637455/how-to-use-ckeditor-in-a-bootstrap-modal
	$.fn.modal.Constructor.prototype.enforceFocus = function () {
		var $modalElement = this.$element;
		$(document).on('focusin.modal', function (e) {
			var $parent = $(e.target.parentNode);
			if (
				$modalElement[0] !== e.target && !$modalElement.has(e.target).length &&
				!$parent.hasClass('cke_dialog_ui_input_select') && !$parent.hasClass('cke_dialog_ui_input_text')
			) {
				$modalElement.focus()
			}
		})
	};

	twbsCalls()
	fullScreen()
	scrollTo()
	// editorIframeYT()
	windowScrollResize()
	// openModals()
	customValidity()
	cookieWarning()
	copyToClipboard()
}

export function colors() {
	const C = {
		brand:             '#53acf5',
		brand_dark:        '#1a7cb5',
		brand_alt:         '#fbb03b',
		brand_alt_lighter: '#fdd79d',
		brand_sec:         '#49338d',
		brand_ter:         '#6fe2bc',
		gray_base:         '#000',
		gray_darkest:      '#333',
		gray_darker:       '#555',
		gray_dark:         '#6a6a6a',
		gray:              '#888',
		gray_light:        '#aaa',
		gray_lighter:      '#dadada',
		gray_lightest:     '#ebebeb',
		brand_primary:     '#53acf5',
		brand_success:     '#128e5f',
		brand_info:        '#1a7cb5',
		brand_warning:     '#ffc107',
		brand_danger:      '#cd0101',
	}

	return {
		get() {
			return $.extend({}, C)
		}
	}
}
